import React from 'react';

const CreateJob = () => {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-gray-900">Create New Job</h1>
        <p className="mt-1 text-sm text-gray-500">
          Create a new repair job for a customer
        </p>
      </div>
      
      <div className="card">
        <p className="text-gray-600">Create job form is under construction.</p>
      </div>
    </div>
  );
};

export default CreateJob;